import { Component } from '@angular/core';
import { Subscription } from 'rxjs';

// Services
import { LoginService } from 'src/app/services/login/login.service';
import { LoginInvitedService } from 'src/app/services/login-invited/login-invited.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent {

  listSubcriptions: Subscription[] = [];

  showLogin: boolean = false;
  showLoginInvited: boolean = false;

  constructor(
    private _loginService: LoginService,
    private _loginInvitedService: LoginInvitedService,
    private _amplitudeService: AmplitudeService
  ){ }

  ngOnInit(): void {
    this.listenerShowLogin();
    this.listenerShowLoginInvited();
    this._amplitudeService.initAmplitude()
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  listenerShowLogin(): void {
    this.listSubcriptions.push(
      this._loginService.getSubjetShowLogin().asObservable().subscribe(
        data => {
          this.showLogin = data;
        }
      )
    );
  }

  listenerShowLoginInvited(): void {
    this.listSubcriptions.push(
      this._loginInvitedService.getSubjetShowLogin().asObservable().subscribe(
        data => {
          console.log('hola');
          
          this.showLoginInvited = data;
        }
      )
    );
  }

}
